<template>
  <tab-layout>
    <li slot="tabHeading" class="nav-item">
      <a
      :class="['nav-link', selectedTab === 'details' ? 'active' : '']"
      href @click.prevent="selectedTab = 'details'" id="details-tab"
      data-toggle="tab"
      role="tab"
      aria-controls="details"
      :aria-selected="selectedTab === 'details' ? 'true' : 'false'">Details</a>
    </li>
    <li slot="tabHeading" class="nav-item">
      <a
      :class="['nav-link', selectedTab === 'score' ? 'active' : '']"
      href @click.prevent="selectedTab = 'score'" id="score-tab"
      data-toggle="tab"
      role="tab"
      aria-controls="score"
      :aria-selected="selectedTab === 'score' ? 'true' : 'false'">Results</a>
    </li>
    <horse-profile-details v-if="selectedTab === 'details'" slot="tabContent" class="tab-pane row mx-0 show active" />
    <horse-profile-score v-if="selectedTab === 'score'" slot="tabContent" class="tab-pane row mx-0 show active" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import horseProfileScore from '@/views/Horses/Profile/HorseProfileScore'
import horseProfileDetails from './HorseDetails'

export default {
  name: 'PendingHorse',
  props: ['details'],
  components: {
    'tab-layout': tabLayout,
    'horse-profile-details': horseProfileDetails,
    'horse-profile-score': horseProfileScore
  },
  data() {
    return {
      pending: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Pending/Horse/Horse.vue